import { z } from 'zod';
import { emptyToUndefined, optionalEmail, optionalPhone, optionalStr } from './utils.js';
/** The possible lifecycle statuses for a client. */
export const ClientStatusSchema = z.enum(['ACTIVE', 'INACTIVE', 'PROSPECT']);
/** Request body for creating a contact on a client. */
export const CreateContactSchema = z.object({
    fullName: z.string().min(1).max(255),
    email: optionalEmail.optional(),
    phone: optionalPhone,
    notes: optionalStr,
    position: z
        .string()
        .optional()
        .transform(emptyToUndefined)
        .pipe(z.string().max(255).optional()),
});
/** Partial version of {@link CreateContactSchema} for PATCH updates. */
export const UpdateContactSchema = CreateContactSchema.partial();
/** Request body for creating a client, including optional nested contacts. */
export const CreateClientSchema = z.object({
    name: z.string().min(1).max(255),
    email: optionalEmail.optional(),
    phone: optionalPhone,
    company: z
        .string()
        .optional()
        .transform(emptyToUndefined)
        .pipe(z.string().max(255).optional()),
    address: optionalStr,
    notes: optionalStr,
    status: ClientStatusSchema.default('ACTIVE'),
    contacts: z.array(CreateContactSchema).optional(),
});
/**
 * Partial version of {@link CreateClientSchema} for PATCH updates. `status` is redeclared
 * without its create-time default, which `.partial()` would otherwise still apply and
 * reset an inactive client to ACTIVE on any partial update.
 */
export const UpdateClientSchema = CreateClientSchema.extend({
    status: ClientStatusSchema,
}).partial();
//# sourceMappingURL=clients.js.map